import { render, staticRenderFns } from "./UiTableForm.vue?vue&type=template&id=a2f58de2&scoped=true"
import script from "./UiTableForm.vue?vue&type=script&lang=js"
export * from "./UiTableForm.vue?vue&type=script&lang=js"
import style0 from "./UiTableForm.vue?vue&type=style&index=0&id=a2f58de2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f58de2",
  null
  
)

export default component.exports